module.exports = __webpack_public_path__ + "static/media/insurance-agent-services-6668AMT-min.bf584904.jpg";